import React from "react";
import { HubDialogWrapper } from "../HubDialogWrapper";
import IndustryContent from "./IndustryContent";

export const IndustryDialog = ({ allIndustries = [] }) => {
  return (
    <HubDialogWrapper maxWidth="sm" name="edit-industry">
      <IndustryContent allIndustries={allIndustries} />
    </HubDialogWrapper>
  );
};

export default IndustryDialog;